import { render, staticRenderFns } from "./Delivery-Detail.vue?vue&type=template&id=040f6ac4"
import script from "./Delivery-Detail.vue?vue&type=script&lang=js"
export * from "./Delivery-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports